import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Package, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { tx } from "@/i18n";

export const supplyKey = (x) => (x.kind === "task" ? x.task_id : `${x.report_id}:${x.item_id}`);

function SupplyLine({ x, showHouse, onDone }) {
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try {
      await api.post(x.kind === "task" ? `/supplies/task/${x.task_id}/done` : `/supplies/report/${x.report_id}/${x.item_id}/done`);
      onDone(x);
    } catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <label className="flex items-start gap-3 py-2.5 border-b border-border last:border-0 cursor-pointer animate-fade-up" data-testid={`supply-line-${supplyKey(x)}`}>
      <Checkbox checked={busy} disabled={busy} onCheckedChange={check} className="mt-0.5" data-testid={`supply-check-${supplyKey(x)}`} />
      <span className="min-w-0 text-sm leading-snug">
        {showHouse && <span className="block text-[11px] font-semibold uppercase tracking-wide text-primary">{x.house_name}</span>}
        <span className="break-words">{x.text}</span>
      </span>
    </label>
  );
}

export function SuppliesDialog({ open, onOpenChange, items, isOwner, onDone }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[calc(100%-2rem)] rounded-xl max-h-[85vh] overflow-y-auto" data-testid="supplies-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="font-display flex items-center gap-2"><Package className="h-5 w-5 text-primary" /> {tx("Benodigdheden")}</DialogTitle>
          <DialogDescription>{isOwner ? tx("Dit regel je zelf. Vink af wat geregeld is.") : tx("Dit regelt Costa Key. Vink af wat geregeld is.")}</DialogDescription>
        </DialogHeader>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground flex items-center gap-2 py-4" data-testid="supplies-empty"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> {tx("Alles is geregeld.")}</p>
        ) : (
          <div data-testid="supplies-list">{items.map((x) => <SupplyLine key={supplyKey(x)} x={x} showHouse={!isOwner || new Set(items.map((i) => i.house_id)).size > 1} onDone={onDone} />)}</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
